module.exports = __webpack_public_path__ + "static/media/Senuri.dc63f240.jpeg";